import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import SalesOrderForm from "./SalesOrderForm/SalesOrderForm";
import { emptySoForm, SO_API, soUrlKey } from "./data";
import { selectedSalesOrderPath } from "components/PimDashboard/data";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import { GlobalState } from "context/GlobalContext";
import { SoPage } from "./soUi";

const CreateSalesOrder = () => {
	const navigate = useNavigate();
	const { snackBar, setSnackBarOpen, setSnackBar } = GlobalState();
	const [form, setForm] = useState(emptySoForm());
	const [saving, setSaving] = useState(false);

	const notify = (message, severity = "success") => {
		setSnackBar({ ...snackBar, message, severity, anchorOrigin: { horizontal: "center", vertical: "top" } });
		setSnackBarOpen(true);
	};

	const handleSave = async () => {
		setSaving(true);
		try {
			const res = await axios.post(`${SO_API}/`, form);
			notify("Sales order draft created");
			navigate(`/${selectedSalesOrderPath}?${soUrlKey}=${res.data.result.id}`);
		} catch (error) {
			notify(parseErrorMessage(error), "error");
		} finally {
			setSaving(false);
		}
	};

	return (
		<SoPage>
			<SalesOrderForm variant="create" value={form} onChange={setForm} onSave={handleSave} saving={saving} />
		</SoPage>
	);
};

export default CreateSalesOrder;
